import React from 'react';

import { useTranslation } from '../../../../../../hooks';
import { T } from '../../../../../../constants';

interface JackpotDetailsHeaderProps {
  onClose: () => void;
}

export const JackpotDetailsHeader: React.FC<JackpotDetailsHeaderProps> = ({ onClose }) => {

  const t= useTranslation();

  return (
    <div className="jackpot-popup-header">
      <h1 className="jackpot-popup-title">{t(T.JACKPOT_DETAILS)}</h1>
      <button className="close-btn" onClick={onClose}>
        <i className="icon-close" />
      </button>
    </div>
  );
};
